import { Injectable } from '@angular/core';
import { Confirmation, ConfirmationService } from 'primeng/api';

@Injectable()
export class AppConfirmationService extends ConfirmationService {
  override confirm(confirmation: Confirmation): this {
    return super.confirm({ rejectVisible: true, ...confirmation });
  }
}
